(function () {
  'use strict';

  var SUGGEST = '/search/suggest.json';
  var LIMIT = 5;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  function money(value) {
    if (value == null || value === '') return '';
    var num = parseFloat(value);
    if (isNaN(num)) return '';
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || null;
    if (!code) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: code, minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(num);
    } catch (e) { return ''; }
  }

  function init(wrap) {
    var input = wrap.querySelector('input[type="search"]');
    var panel = wrap.querySelector('[data-nw-sugg]');
    if (!input || !panel) return;

    var timer = null;
    var lastQuery = '';
    var controller = null;
    var index = -1;

    function close() {
      panel.hidden = true;
      wrap.classList.remove('is-open');
      index = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    function open() {
      if (!panel.innerHTML.trim()) return;
      panel.hidden = false;
      wrap.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    function items() {
      return Array.prototype.slice.call(panel.querySelectorAll('a'));
    }

    function highlight(n) {
      var list = items();
      if (!list.length) return;
      list.forEach(function (a) { a.classList.remove('is-active'); });
      if (n < 0) n = list.length - 1;
      if (n >= list.length) n = 0;
      index = n;
      list[index].classList.add('is-active');
      list[index].scrollIntoView({ block: 'nearest' });
    }

    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var collections = r.collections || [];
      var queries = r.queries || [];
      var html = '';

      if (queries.length) {
        html += '<p class="nw-sugg__label">Suggestions</p><ul class="nw-sugg__list nw-sugg__list--terms">';
        queries.slice(0, 3).forEach(function (item) {
          html += '<li><a href="/search?q=' + encodeURIComponent(item.text) + '" class="nw-sugg__term">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20.5 20.5 16.6 16.6" stroke-linecap="round"/></svg>' +
            '<span>' + esc(item.text) + '</span></a></li>';
        });
        html += '</ul>';
      }

      if (collections.length) {
        html += '<p class="nw-sugg__label">Categories</p><ul class="nw-sugg__list nw-sugg__list--cats">';
        collections.slice(0, 3).forEach(function (c) {
          html += '<li><a href="' + esc(c.url) + '" class="nw-sugg__cat">' + esc(c.title) + '</a></li>';
        });
        html += '</ul>';
      }

      if (products.length) {
        html += '<p class="nw-sugg__label">Baskets</p><ul class="nw-sugg__list">';
        products.slice(0, LIMIT).forEach(function (p) {
          html += '<li><a href="' + esc(p.url) + '" class="nw-sugg__item">' +
            (p.image ? '<img src="' + esc(thumb(p.image)) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="nw-sugg__ph"></span>') +
            '<span class="nw-sugg__t">' + esc(p.title) +
            (money(p.price) ? '<em class="nw-sugg__p">' + esc(money(p.price)) + '</em>' : '') +
            '</span></a></li>';
        });
        html += '</ul>';
      }

      if (!html) {
        html = '<p class="nw-sugg__empty">Nothing matches &ldquo;' + esc(q) + '&rdquo; yet. Try a shape or a size.</p>';
      } else {
        html += '<a class="nw-sugg__all" href="/search?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
      }

      panel.innerHTML = html;
      open();
    }

    function fetchSuggest(q) {
      if (controller) controller.abort();
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var url = SUGGEST + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=' + LIMIT +
        '&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (res) { return res.json(); })
        .then(function (data) { render(data, q); })
        .catch(function () { /* aborted or offline — stay quiet */ });
    }

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); panel.innerHTML = ''; lastQuery = ''; return; }
      if (q === lastQuery) { open(); return; }
      lastQuery = q;
      timer = setTimeout(function () { fetchSuggest(q); }, 180);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && panel.innerHTML.trim()) open();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(index + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(index - 1); }
      else if (e.key === 'Enter' && index > -1) {
        var list = items();
        if (list[index]) { e.preventDefault(); window.location.href = list[index].href; }
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });

    wrap.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!wrap.contains(document.activeElement)) close();
      }, 120);
    });
  }

  function boot() {
    document.querySelectorAll('[data-nw-search]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
